import { useMutation } from 'react-query';

import { modifyClustersList as mutationFn } from 'api/endPoints/modifyClustersList';

export const useMutationDeleteTaskFromCluster = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    taskIds: number[];
    clusterId: number;
    clusterType: string;
}
